import React from 'react'
import PropTypes from 'prop-types'
import { ListItem, TimeIndicator, ChatBubble, ChatText } from '../../style.js'

const Admin = ({ msg, date, isImage, isMobile }) => {
  const { message, messageId } = msg
  return (
    <ListItem key={messageId} isImage={isImage} isMobile={isMobile}>
      <TimeIndicator>{date}</TimeIndicator>
      <ChatBubble>
        <ChatText>{message}</ChatText>
      </ChatBubble>
    </ListItem>
  )
}

Admin.propTypes = {
  msg: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  isImage: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
}

export default Admin
